{
	"deleteDescription": "El invitado será eliminado permanentemente. ¿Quieres continuar de todos modos?",
	"deleteGuest": "Eliminar invitado",
	"emptyText": "No hay datos para mostrar.",
	"excludeGuest": "Eliminar invitado",
	"reports": {
		"goTo": "Vete a",
		"cashierAdjustmentsReport": {
			"adjustmentTypes": {
				"bleeding": "Sangría",
				"pettyCash": "Fondo de cambio"
			},
			"cashierAdjustmentForm": {
				"errors": {
					"emptyValue": "Escriba un valor"
				},
				"inputLabels": {
					"obs": "Comentarios",
					"value": "Valor"
				}
			},
			"cashierAdjustmentModal": {
				"title": "Añadir {{adjustmentType}}",
				"notAllowedText": "Esta acción no se puede realizar cuando el evento ya ha finalizado."
			},
			"excelFileName": "Ajustes de cajero-{{timestamp}}",
			"filters": {
				"byAuthor": {
					"label": "Filtrar por empleado",
					"placeholder": "Seleccione un empleado"
				},
				"byCashier": {
					"label": "Filtrar por cajero",
					"placeholder": "Seleccione un cajero"
				},
				"byType": {
					"label": "Filtrar por tipo",
					"placeholder": "Seleccione un tipo"
				}
			},
			"successfullExportMsg": "Spreadsheet exportado correctamente!",
			"table": {
				"columns": {
					"author": "Empleado",
					"cashier": "Cajero",
					"obs": "Comentarios",
					"timestamp": "Fecha/Hora",
					"type": "Tipo",
					"value": "Valor"
				}
			},
			"title": "Sangrías y Fondo de cambio",
			"exchangeTotal": "Total en fondo de cambio",
			"cashWithdrawal": "Total en sangrado"
		},
		"clientsReportTable": {
			"appTransactionsValue": "Pago por APP",
			"bonusTransactionsValue": "Pagado con bonus",
			"cpf": "DNI",
			"customerConsumption": "Consumo por cliente",
			"editData": "Editar datos",
			"empty": "No hay datos para mostrar.",
			"filename": "Consumo por cliente",
			"hasApp": "Tiene APP",
			"housePostPaidTransactionsValue": "Ya pagado en el local",
			"housePrePaidTransactionsValue": "Prepagado en el local",
			"invoices": "Facturas",
			"name": "Nombre",
			"noApp": "No tengo aplicación",
			"phone": "Teléfono",
			"searchClient": "Busca un cliente aquí",
			"seeExtract": "Ver extracto",
			"title": "Consumo por cliente",
			"total": "Total",
			"zigCode": "ZigCode"
		},
		"cmvReportTable": {
			"mountableCaps": "COMPUESTO",
			"mountable": "Producto compuesto",
			"name": "Nombre",
			"section": "Sección",
			"count": "Cantidad",
			"productUnitCost": "Coste unitario",
			"total": "Coste total"
		},
		"rappiDiscount": {
			"date": "Fecha",
			"employee": "Empleado que aplicó el descuento",
			"emptyText": "No hay datos para mostrar.",
			"products": "Productos",
			"value": "Valor del descuento"
		},
		"reserveReportTable": {
			"confirmedPeople": "{{value}} Clientes confirmados",
			"confirmedPeopleExcel": "Confirmado",
			"count": "Qty.",
			"date": "Fecha del paquete",
			"discount": "Descuento",
			"discountTooltip": "Cualquier descuento en la cuenta es parte de este valor",
			"downloadTable": "Descargar tabla",
			"filenameExcel": "Paquetes",
			"filenameExcelDetails": "package_details_",
			"invitedPeople": "Invitados",
			"issued": "Emisión de facturas",
			"issuedInvoices": "Emisión de factura",
			"name": "Nombre",
			"noPromotion": "Productos fuera de promoción",
			"packageName": "Nombre del paquete",
			"productName": "Total",
			"productNameExcel": "Producto",
			"products": "Productos",
			"promotionName": "Promoción",
			"receivedValue": "Cantidad recibida",
			"reserveValue": "incluido en valor de paquete",
			"revenue": "Facturación",
			"selledCount": "Cantidad",
			"ticketTooltip": "Ticket medio de los clientes del paquete",
			"tips": "Propinas",
			"title": "Detalles del paquete",
			"titleExcel": "Paquetes",
			"titleExcelDetails": "Detalles del paquete ",
			"total": "Facturación total",
			"totalProductsValue": "facturado en productos",
			"totalValue": "Valor total",
			"unitValue": "Valor unitario",
			"value": "Valor del paquete"
		},
		"stockReportTable": {
			"bar": "Bar",
			"category": "Transferido desde {{product}}",
			"employeeBar": "Empleado del bar",
			"quantity": "Cantidad",
			"stocker": "Control de stock",
			"time": "Hora",
			"title": "Transferencias de stock"
		}
	}
}
